export const LOCALE_SELECTED = 'LOCALE_SELECTED';
